export const RIBBON_LIST_DEFAULT_SORT = {
  sortedColumn: 'activeFrom',
  sortedColumnOrder: 'descend'
}

export const RIBBON_RPIORITIES_LIST = {
  1: 'success',
  2: 'warning',
  3: 'error'
}
